import Backend from 'backend';
import {inject} from 'aurelia-framework';
import {Router} from 'aurelia-router';

@inject(Backend, Router)
export class PackagingDetailsScreen {
    backend;
    router;

    packaging;

    showDeleteConfirm = false;
    deleteError;

    constructor(backend, router) {
        this.backend = backend;
        this.router = router;
    }

    activate(params) {
        return this.backend.PackagingCrud_details(params.packagingId)
                    .then(packaging => this.packaging = packaging);
    }
}
